import React, { useCallback } from "react";
import { Input } from "../../style/Input";
import { LoginLabel } from "../../style/Label";
import {
  LoginHeading,
} from "../../style/Login";
import { Button } from "../../style/Button";
import { useHistory } from "react-router-dom";
import { Logo1 } from "../logo/Logo";
import jsonwebtoken from "jsonwebtoken";
import { serverUrl } from "../../appconst";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import "./login.css";
export class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      openDialog: sessionStorage.getItem("signup") && sessionStorage.getItem("signup") === "success" ? true : false
    };

    this.handleOnClick = this.handleOnClick.bind(this);
    this.forwardTOHome = this.forwardTOHome.bind(this);
    let data = JSON.parse(window.sessionStorage.getItem("usersession"));

    if (data && data.message !== "User Not found.") {
      var isExpired = false;
      const token = data.accessToken;
      var decodedToken = jsonwebtoken.decode(token, { complete: true });
      var dateNow = new Date();

      if (decodedToken.exp < dateNow.getTime()) isExpired = true;
      this.forwardTOHome();
    }

  }
  // const history = useHistory();
  //const handleOnClick = useCallback(() => history.push('/partner-home'), [history]);

  forwardTOHome = () => {
    this.props.history.push({
      pathname: "/partner-home",
    });
  };

  handleOnClick = () => {
    fetch(serverUrl + "/api/auth/signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: this.state.username,
        password: this.state.password,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (
          data.message === "User Not found." ||
          data.message === "Invalid Password!"
        ) {
          alert(data.message);
        } else {
          window.sessionStorage.setItem("usersession", JSON.stringify(data));
          this.forwardTOHome();
        }
      })
      .catch(console.log);
  };

  render() {
    return (
      <>
          <Grid container className="min-h-100 main-box" maxWidth="100%" alignContent="center">
            <Grid
              item xs={12}
              md={6}
              justifyContent="center"
              alignContent="center"
              className="min-h-100 info-wrap"
            >
              <Logo1  />
              <Box className="content-wrap info">
                <div className="info-text">
                  <p style={{ marginBottom: "6px", lineHeight:"28px"}}>
                    <b className="fs27">Doceree</b><br/>
                    <b className="fs27">Partner Toolbox</b>
                  </p>
                  <p className="info-subtext">
                    A solution hub primarily for our agency partners
                  </p>
                  <br />
                  <p className="info-link mt-0-xs">
                    <span style={{ fontWeight: 600 }}>Partner Toolbox is a mutual collaboration 
                    between Doceree and agency partners</span> who are
                    looking to showcase the possibilities of reaching
                    out to HCPs to their life sciences clients. It
                    supports the partners to demonstrate new and
                    innovative ways of engaging with HCPs in an
                    convenient manner.
                  </p>
                  <p className="info-link">
                      To request an access, reach out to your customer success representative or <span
                        display="block"
                        color="#969696"
                        margin="20px 0px 10px 18%"
                        onClick={() => this.props.history.push({
                          pathname: "/signup",
                        })} style={{ color: "#B263DE", fontWeight: "600", cursor: 'pointer' }} >click here</span>
                  </p>
                </div>
              </Box>
          </Grid>
          <Grid item xs={12} md={6} className="form-wrap">
            <Box className="content-wrap mt-0-xs">
              <Box>
                <LoginHeading>Log In</LoginHeading>
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="10px 0px 10px 0"
                >
                  Username:{" "}
                </LoginLabel>
                <Input
                  height="45px"
                  width="356px"
                  margin="10px 0px 0px 0"
                  onChange={(event) =>
                    this.setState({ username: event.target.value })
                  }
                  placeholder=""
                />
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="20px 0px 10px 0"
                >
                  Password{" "} <span className="forgot-pwd">Forgot Password?</span>
                </LoginLabel>
                <Input
                  height="45px"
                  width="356px"
                  margin="10px 0px 0px 0"
                  type="password"
                  onChange={(event) =>
                    this.setState({ password: event.target.value })
                  }
                  placeholder=""
                />
                <Button
                  width="356px"
                  marginTop="40px"
                  height="45px"
                    backgroundImage="linear-gradient(to right,#A45BE4 0%, #6B42F6 70%)"
                  style={{ fontWeight: 600, fontSize: "13.8px" }}
                  onClick={this.handleOnClick}
                >
                  Log In
                </Button>
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="20px 0px 10px 0"
                  className="text-center-xs"
                  onClick={() => this.props.history.push({
                    pathname: "/signup",
                  })}
                >
                  Not a member? <span style={{ color: "#B263DE", fontWeight: "600", cursor: 'pointer' }} >Sign up</span>
                </LoginLabel>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Dialog
          open={this.state.openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ maxWidth: "40vw", marginLeft: "auto", marginRight: "auto", width: "448px", textAlign: 'center' }}
        >
          <DialogContent>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              style={{ float: "right" }}
              onClick={(event) => {
                this.setState({ openDialog: false })
                sessionStorage.removeItem("signup")
              }
              }
            >
              <span style={{ float: "right", fontSize: "16px", textAlign: "left" }}>X</span>
            </IconButton>
            <DialogContentText id="alert-dialog-description" style={{ marginTop: "40px", padding: "30px" }}>
              Thank you for your interest in Doceree's Partner Toolbox.<br /><br />
              Our customer success representative will contact you shortly.
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}